<template>
  <div class="custom-toast" :style="toastStyle" v-show="visible">
    <div v-if="content" class="toast-content">{{ content }}</div>
    <div v-if="message" class="toast-message">{{ message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
    message: String,
    bottom: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      visible: false,
      timer: null
    }
  },
  computed: {
    toastStyle() {
      if (this.bottom) {
        return {
          bottom: this.bottom,
          top: 'auto',
          transform: 'translateX(-50%)'
        }
      } else {
        return {
          top: '50%',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)'
        }
      }
    }
  },
  mounted() {
    this.visible = true
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        this.visible = false
        setTimeout(() => this.remove(), 300)
      }, this.duration)
    }
  },
  methods: {
    remove() {
      this.$el && this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
    }
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer)
  }
}
</script>

<style scoped>
.custom-toast {
  position: fixed;
  left: 50%;
  z-index: 9999;
  max-width: 70%;
  min-width: 150px;
  padding: 13px 16px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  box-sizing: border-box;
  pointer-events: none;
  transition: opacity 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px 0;
}
.toast-content {
  font-weight: 500;
  font-size: 15px;
  color: rgba(255, 255, 255, 1);
}
.toast-message {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
}
</style>
